var locale = {
  placeholder: 'Избери време'
};
export default locale;